export const calloutSettings = {
  challenges: {
    color: "#352281",
    icon: "wrench",
    label: "Challenges",
  },
  solutions: {
    color: "#8630A3",
    icon: "bulb",
    label: "Solutions",
  },
  cashouts: {
    color: "#007F9C",
    icon: "wallet-move",
    label: "Total cashouts",
  },
};
